<div class="question-title asterisk">
    <svg-icon *ngIf="question?.requierd" svgClass="svg-img-mini img" src="/assets/images/question-menu/asterisk.svg"></svg-icon>
    <img *ngIf="question?.type?.image" class="image-type" src="/assets/images/types/{{question?.type?.image}}" />
    <input queDisplayByType [name]="'inputTitle'" [typeId]="typeId"
        placeholder="{{'questionBoard.edit.TitleCome' | translate}}" [formControl]="title"
        [style.color]="color$ | async">
    <input queDisplayByType [name]="'inputTitleToImage'" [typeId]="typeId"
        placeholder="{{'questionBoard.edit.questionComeImage' | translate}}" [formControl]="title"
         [style.color]="color$ | async">
</div>
